import { Form, Space, Row, Col, Button, Spin, message, Checkbox } from "antd";
import { useForm } from "antd/es/form/Form";
import {
  LoginJson,
  LoginPostJson,
  LoginPostJson as LoginType,
  SignupStatusJson,
} from "../types/auth.type";
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  useCheckSenderMutation,
  useForgotPasswordMutation,
  useLoginMutation,
  useSenderMutation,
  useSettingQuery,
} from "../service/auth.service";

import type { FormInstance } from "antd/es/form";
import { useAppDispatch, useAppSelector } from "app/hooks";
import {
  clearToken,
  selectCallbackUrl,
  selectToken,
  selectUser,
  setErrorsAuth,
  setSaveSignInAuth,
  setToken,
  setUser,
} from "../AuthSlice";
import { ErrorComment } from "features/comment/types/comment.type";
import { useTranslation } from "react-i18next";
import {
  createSearchParams,
  redirect,
  unstable_HistoryRouter,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { NoticeType } from "antd/es/message/interface";
import Setting from "setting";
import Loyalty from "common/constants/Loyalty";
import AuthButton from "../components/AuthButton";
import AuthInput from "./../components/AuthInput";
import AuthResTranslate from "./../components/AuthResTranslate";
import {
  convertErrorUnwrap,
  isEntityError,
  isFetchError,
} from "common/utils/errorResultRTK";
import { useCookies } from "react-cookie";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import AuthWrapperForm from "../components/AuthWrapperForm";
import { CheckCircleOutlined, CheckCircleFilled } from "@ant-design/icons";
import AuthPopup from "../components/AuthPopup";
import CustomerConstants from "common/constants/Customer";
import SettingApi from "common/constants/SettingApi";
import { getApiSetting } from "utils/getSetting";
import { navigateCallBack } from "utils/navigateCallback";
type Props = {
  handleLoginSuccess?: () => void;
  handleBeforeLoginSuccess?: () => void;
  noRegister?: boolean;
  styleWrapper?: React.CSSProperties | undefined;
};
const Login = ({
  handleLoginSuccess,
  handleBeforeLoginSuccess,
  noRegister = false,
  styleWrapper,
}: Props) => {
  //
  const [form] = useForm();
  const { t } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();
  const location = useLocation();
  const [cookies, setCookies, removeCookies] = useCookies([
    "time-out",
    "used",
    "account-id",
    "quota",
  ]);
  const [searchParams] = useSearchParams();
  //
  //
  const buttonRef = useRef<HTMLButtonElement>(null);
  const buttonFirstLoginRef = useRef<HTMLButtonElement>(null);
  const windowWidth = useRef(window.innerWidth);

  const errorsLogin = useAppSelector((state) => state.auth.errors);
  //
  const dispatch = useAppDispatch();
  //////////////////////////////////
  const formRef = React.useRef<FormInstance>(null);
  const token = useAppSelector(selectToken);
  //
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string[]>([]);
  //
  const [status, setStatus] = useState<string>("");
  const [saveSignIn, setSaveSignIn] = useState<boolean>(true);
  const [isSubmitLogin, setSubmitLogin] = useState<boolean>(false);
  const [isErrorUnActive, setIsErrorUnActive] = useState<boolean>(false);
  const [activePhone, setActivePhone] = useState<string>("");
  //
  const [after_login_url, setAfter_login_url] = useState("");
  const [after_login_first_url, setAfter_login_first_url] = useState("");
  const [popup_welcome, setPopup_welcome] = useState("");
  const [callbackUrl] = useState(searchParams.get("callbackUrl") || "");

  //////////////////////
  const [login, { isSuccess, isError }] = useLoginMutation();
  const [checkSender, checkSenderResult] = useCheckSenderMutation();

  /////////////////////////
  //functions
  const handleMessageApi = ({
    content,
    type,
  }: {
    content: React.ReactNode;
    type: NoticeType | undefined;
  }) => {
    messageApi.open({
      content: content,
      type: type,
      duration: 2,
    });
  };

  const fetchFirstNavigate = async ({
    account_id,
    status,
    type,
  }: {
    account_id: string;
    status: SignupStatusJson;
    type: number;
  }) => {
    try {
      const response = await checkSender({
        account_id: account_id,
        type: type,
      }).unwrap();
      if (response) {
        if (response) {
          if (cookies["account-id"] !== account_id) {
            setCookies("time-out", -1, { path: "/" });
          }
          navigate({
            pathname: CustomerConstants.LINK_ROUTER.LOGIN.VERIFY_OTP,
            search: `?${createSearchParams({
              type: JSON.stringify(type),
              account_id: account_id,
              status: status,
              callbackurl: CustomerConstants.LINK_ROUTER.LOGIN.INDEX,
            })}`,
          });
        }
      }
    } catch (err) {
      const convertError = convertErrorUnwrap(err);
      if (
        convertError.error.some((err) =>
          err.includes(Loyalty.ERRORS.ERROR_OTP_ALREADY)
        )
      ) {
        navigate(
          {
            pathname: "/verifyotp",
            search: `?${createSearchParams({
              account_id: account_id,
              status: status,
              type: JSON.stringify(type),
            })}`,
          },
          {
            state: {
              otp_timeout: cookies["time-out"],
              otp_used: cookies["used"],
              otp_quota: cookies["quota"],
            },
          }
        );
      } else {
        // setError(convertError.error);
        // messageApi.open({
        //   content: t(
        //     `customer:errors.${
        //       convertError.error.length > 0
        //         ? convertError.error[0]
        //         : convertError.status
        //     }`
        //   ),
        //   duration: 4,
        //   type: "error",
        // });
        // setError(convertError.error);
      }
    }
  };

  const handleProcessLogin = async (
    response: LoginJson,
    formData: LoginPostJson
  ) => {
    switch (response.status) {
      case "SUCCESS": // Đăng nhập thành công
        if (callbackUrl.length > 0) {
          window.location.href = atob(callbackUrl);
        } else {
          if (after_login_url.startsWith("http")) {
            window.location.href = after_login_url;
          } else {
            navigate(after_login_url, { replace: true });
            navigate(0);
          }
        }
        // if (callbackLink.length > 0) {
        //   navigateCallBack({
        //     callbackLink: callbackLink,
        //     handleNavigate: () => {
        //       navigate(callbackLink);
        //     },
        //   });
        // } else {
        //   if (response.first_login) {
        //     // buttonRef.current?.click();
        //     if (after_login_first_url.startsWith("http")) {
        //       window.location.href = after_login_first_url;
        //     } else {
        //       navigate(
        //           after_login_first_url,
        //         {
        //           replace: true,
        //         }
        //       );
        //     }
        //   } else {
        //     if (after_login_url.startsWith("http")) {
        //       window.location.href = after_login_url;
        //     } else {
        //       navigate(after_login_url, { replace: true });
        //     }
        //   }
        // }

        break;
      case Loyalty.STATUS_CUSTOMER.CUSTOMER_ALREADY: // khách cũ chưa có tài khoản , -> thiết lập mật khẩu
        // dispatch(setErrorsAuth({ errors: ["CUSTOMER_ALREADY"] }));
        setError([Loyalty.VERIFY.CUSTOMER_ALREADY]);
        setStatus(Loyalty.STATUS_CUSTOMER.CUSTOMER_ALREADY);
        break;
      default:
        messageApi.open({
          duration: 3,
          content: "Đăng nhập thành công",
          type: "success",
        });
        handleLoginSuccess && handleLoginSuccess();
        break;
    }
  };

  const handleSaveSignIn = (e: CheckboxChangeEvent) => {
    setSaveSignIn(e.target.checked);
    dispatch(setSaveSignInAuth(e.target.checked));
  };

  const handleProcessLogout = () => {
    dispatch(clearToken());
  };

  const handleGetSetting = async () => {
    const link_login = await getApiSetting({
      key: SettingApi.LOYALTY.after_login_url.key,
    });
    const link_login_first = await getApiSetting({
      key:
        windowWidth.current > 768
          ? SettingApi.LOYALTY.after_login_first_url.key_desktop
          : SettingApi.LOYALTY.after_login_first_url.key_mobile,
    });
    const link_popup_welcome = await getApiSetting({
      key:
        windowWidth.current > 768
          ? SettingApi.LOYALTY.loyalty_popup_wellcome_desk.key
          : SettingApi.LOYALTY.loyalty_popup_wellcome_mob.key,
    });

    /////////////////

    if (!link_login.hasError()) {
      setAfter_login_url(link_login.value);
    } else {
      setAfter_login_url(SettingApi.LOYALTY.after_login_url.default);
    }

    if (!link_login_first.hasError()) {
      setAfter_login_first_url(link_login_first.value);
    } else {
      setAfter_login_first_url(
        SettingApi.LOYALTY.after_login_first_url.default
      );
    }

    if (!link_popup_welcome.hasError()) {
      setPopup_welcome(link_popup_welcome.value);
    } else {
      setPopup_welcome(
        windowWidth.current > 768
          ? SettingApi.LOYALTY.loyalty_popup_wellcome_desk.default
          : SettingApi.LOYALTY.loyalty_popup_wellcome_mob.default
      );
    }
  };

  const handleActiveAccount = () => {
    const account_id = formRef.current?.getFieldValue("account_id");
    if (account_id && account_id.length > 0) {
      if (cookies["account-id"] !== account_id) {
        setCookies("time-out", -1, { path: "/" });
      }
      navigate({
        pathname: "/verifyotp",
        search: `?${createSearchParams({
          type: JSON.stringify(Loyalty.VERIFY.TYPE_CUSTOMER_ACTIVE),
          account_id: account_id,
          status: Loyalty.STATUS_CUSTOMER.CUSTOMER_UNACTIVATED,
          tax: activePhone,
          callbackurl: CustomerConstants.LINK_ROUTER.LOGIN.INDEX,
        })}`,
      });
    }
  };

  /////////////////////////
  const onLogin = async (formData: LoginType) => {
    setSubmitLogin(true);
    setLoading(true);
    setStatus("");
    handleBeforeLoginSuccess && handleBeforeLoginSuccess();
    try {
      const responseLogin = await login({
        account_id: formData.account_id.trim(),
        password: formData.password,
      }).unwrap();
      if (responseLogin) {
        handleProcessLogin(responseLogin, formData);
      }
      // handleProcessLogin("", formData);
    } catch (err: any) {
      const convertError = convertErrorUnwrap(err);
      if (
        convertError.error.includes(Loyalty.ERRORS.ERROR_CUSTOMER_UNACTIVATED)
      ) {
        setActivePhone(err.data.active_phone);
        setIsErrorUnActive(true);
      } else if (
        convertError.error.includes(Loyalty.ERRORS.ERROR_JWT_HASH_NOT_FOUND)
      ) {
        handleProcessLogout();
      } else {
        setError(convertError.error);
      }
    }

    setLoading(false);
  };

  const onFill = () => {
    formRef.current?.setFieldsValue({
      account_id: "toan.le@beme.vn",
      password: "toan.le@beme.vn",
    });
  };

  const onForgotPassword = () => {
    let destination = formRef.current?.getFieldValue("account_id") || "";
    navigate({
      pathname: "/forgotpassword",
      search: `?${createSearchParams({
        account_id: destination,
        type: JSON.stringify(Loyalty.VERIFY.TYPE_CUSTOMER_FORGOTPASSWORD),
      })}`,
    });
  };

  const onEstablishPassword = () => {
    const account_id = formRef.current?.getFieldValue("account_id");
    if (account_id && account_id.length > 0) {
      fetchFirstNavigate({
        account_id: account_id,
        status: "CUSTOMER_ALREADY",
        type: Loyalty.VERIFY.TYPE_CUSTOMER_CREATEPASSWORD,
      });
    } else {
      navigate({
        pathname: CustomerConstants.LINK_ROUTER.LOGIN.FORGOT_PASSWORD,
        search: `?${createSearchParams({
          account_id: account_id,
          type: JSON.stringify(Loyalty.VERIFY.TYPE_CUSTOMER_CREATEPASSWORD),
        })}`,
      });
    }
  };

  //////////////////////////

  const isActiveAccount: boolean = useMemo(() => {
    if (isErrorUnActive) {
      return true;
    } else {
      return false;
    }
  }, [isErrorUnActive]);

  ///////////////////////

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [popupHeading, setPopupHeading] = useState<string>(
    "Lấy lại mật khẩu thành công"
  );
  const [popupContent, setPopupContent] = useState<React.ReactElement>(
    <>
      <p>Bạn đã thực hiện Lấy lại mật khẩu thành công!</p>
      <p>Đăng nhập để truy cập vào hệ thống nhé.</p>
    </>
  );

  useEffect(() => {
    handleGetSetting();
  }, []);

  useEffect(() => {
    if (token) {
      if (callbackUrl.length > 0) {
        window.location.href = atob(callbackUrl);
      } else {
        navigate({
          pathname:
            CustomerConstants.LINK_ROUTER.CUSTOMER.INDEX +
            CustomerConstants.LINK_ROUTER.CUSTOMER.MY_COUPON,
        });
      }

      // // buttonRef.current?.click();
      // navigate(0);
    }
  }, [token]);

  useEffect(() => {
    if (errorsLogin.length > 0) {
      if (errorsLogin.includes("RESET_FORGOT_SUCCESS")) {
        setIsOpen(true);
        setPopupHeading("Lấy lại mật khẩu thành công");
        setPopupContent(
          <>
            <p>Bạn đã thực hiện Lấy lập mật khẩu thành công!</p>
            <p>Đăng nhập để truy cập vào hệ thống nhé.</p>
          </>
        );
      } else if (errorsLogin.includes("RESET_CREATE_SUCCESS")) {
        setIsOpen(true);
        setPopupHeading("Thiết lập mật khẩu thành công");
        setPopupContent(
          <>
            <p>Bạn đã thực hiện Thiết lập mật khẩu thành công!</p>
            <p>Đăng nhập để truy cập vào hệ thống nhé.</p>
          </>
        );
      } else if (errorsLogin.includes("CREATE_ACCOUNT_SUCCESS")) {
        setIsOpen(true);
        setPopupHeading("Tạo tài khoản thành công");
        setPopupContent(
          <>
            <p>Bạn đã thực hiện Tạo tài khoản thành công!</p>
            <p>Đăng nhập để truy cập vào hệ thống nhé.</p>
          </>
        );
      }
    }
  }, [errorsLogin]);

  return (
    <AuthWrapperForm>
      <div className="auth_login" style={{ ...styleWrapper }}>
        <AuthPopup
          content={popupContent}
          open={isOpen}
          onClose={() => {
            setIsOpen(false);
            dispatch(setErrorsAuth({ errors: [] }));
          }}
          heading={popupHeading}
        />
        {contextHolder}
        <Space direction="vertical" style={{ display: "block" }}>
          <Spin spinning={loading}>
            <div style={{ marginBottom: 40 }}>
              <button
                ref={buttonRef}
                style={{ visibility: "hidden" }}
                onClick={(e) => {
                  // handleRedirectLogin();
                  e.preventDefault();
                  navigate(
                    {
                      pathname:
                        CustomerConstants.LINK_ROUTER.CUSTOMER.INDEX +
                        CustomerConstants.LINK_ROUTER.CUSTOMER.MY_COUPON,
                    },
                    {
                      replace: true,
                    }
                  );
                }}
              ></button>
              <button
                ref={buttonFirstLoginRef}
                style={{ visibility: "hidden" }}
                onClick={() => {
                  navigate(
                    {
                      pathname:
                        CustomerConstants.LINK_ROUTER.CUSTOMER.INDEX +
                        CustomerConstants.LINK_ROUTER.CUSTOMER.MY_PROFILE,
                    }
                    // {
                    //   state: {
                    //     linkPopupWelcome: dataSetting?.value,
                    //   },
                    // }
                  );
                }}
              ></button>
              <p className="auth_login_heading" style={{ textAlign: "center" }}>
                Đăng Nhập
              </p>
              <div className="auth_login_des">
                <Checkbox
                  defaultChecked={true}
                  onChange={(e) => handleSaveSignIn(e)}
                >
                  Lưu thông tin đăng nhập
                </Checkbox>
              </div>
            </div>
            <Form
              name="normal_login"
              className="login-form"
              onFinish={onLogin}
              ref={formRef}
              validateTrigger={isSubmitLogin ? "onChange" : "onSubmit"}
              onChange={() => {
                if (
                  formRef.current
                    ?.getFieldsError(["account_id", "password"])
                    .some((i) => i.errors.length === 0)
                ) {
                  setError([]);
                  setStatus("");
                  setIsErrorUnActive(false);
                }
              }}
            >
              <Row gutter={[12, 8]}>
                <Col span={24}>
                  <AuthInput
                    name="account_id"
                    placeholder="Email/ Số điện thoại/ Tên đăng nhập"
                    styleFormItem={{ marginBottom: 19 }}
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập.",
                      },
                    ]}
                  ></AuthInput>
                </Col>

                <Col span={24}>
                  <AuthInput
                    styleFormItem={{ marginBottom: 0 }}
                    name="password"
                    type="password"
                    placeholder="Mật khẩu"
                    rules={[{ required: true, message: "Vui lòng nhập." }]}
                  ></AuthInput>
                </Col>
              </Row>
              {(status.length > 0 || error.length > 0) && (
                <AuthResTranslate
                  status={status}
                  error={error[0]}
                  mode="login"
                ></AuthResTranslate>
              )}
              {isActiveAccount && (
                <>
                  <p className="auth_error">
                    Tài khoản của bạn đã được đăng ký tài khoản nhưng chưa kích
                    hoạt.
                  </p>
                  <p className="auth_error">
                    Vui lòng hoàn tất{" "}
                    <span
                      className="auth_link"
                      onClick={() => handleActiveAccount()}
                    >
                      Xác thực Đăng ký
                    </span>{" "}
                    để kích hoạt tài khoản.
                  </p>
                  <p className="auth_error">
                    Hoặc thay đổi Số điện thoại để tiếp tục đăng nhập.
                  </p>
                </>
              )}
              <Form.Item style={{ marginBottom: 0, marginTop: 10 }}>
                <Row gutter={[4, 16]}>
                  {status.length > 0 &&
                  status === Loyalty.STATUS_CUSTOMER.CUSTOMER_ALREADY ? (
                    <Col span={24} style={{ textAlign: "right" }}>
                      <span
                        style={{
                          cursor: "pointer",
                          fontSize: "12px",
                          fontWeight: 500,
                          color: "#004B8F",
                        }}
                        onClick={onEstablishPassword}
                      >
                        Thiết lập mật khẩu
                      </span>
                    </Col>
                  ) : (
                    <Col span={24}>
                      <span
                        style={{
                          cursor: "pointer",
                          fontSize: "12px",
                          fontWeight: 500,
                          textAlign: "left",
                        }}
                        onClick={onForgotPassword}
                      >
                        Quên mật khẩu?
                      </span>
                    </Col>
                  )}
                  <Col span={24}>
                    <AuthButton
                      type="submit"
                      label="Đăng nhập"
                      mode="dark"
                      disabled={loading}
                    ></AuthButton>
                  </Col>
                  {/* <Col span={12} style={{ textAlign: "right" }}>
                  <Button type="link" htmlType="button" onClick={onFill}>
                    Fill form
                  </Button>
                </Col> */}

                  {/* <Col span={24}>
                  <Button
                    type="link"
                    htmlType="button"
                    onClick={onResetPassword}
                  >
                    Thiết lập mật khẩu?
                  </Button>
                </Col> */}
                </Row>

                {/* Or <a href="">register now!</a> */}
              </Form.Item>
            </Form>
          </Spin>
        </Space>
      </div>
    </AuthWrapperForm>
  );
};

export default Login;
